export const benefitsLabels = {
  SKIN_CANCER_CHECK: "Joya Annual Skin Check Mapping (Skin Cancer Check)",
  SKIN_CARE_PRODUCT_DISCOUNT: "Skin Care Product Discount",
  FREE_FACIAL_OR_PEEL: "Joya Treatment Benefit Mapping (Free Facial or Peel)",
  FREE_AESTHETIC_CONSULTATION: "Free Aesthetic Consultation ",
  FREE_SUNSCREEN: "Joya Sunscreen Benefit Mapping",
  WALLET_CREDIT: "The $125 quarterly credit",
};
